import containsUnsupportedCharacters from './containsUnsupportedCharacters';
import type { DeliveryAddressInfo } from '../typings/basket.types';

export interface ValidateAddressResponse {
    isValid: boolean;
    errors: string[];
}

const validateAddress = (data: DeliveryAddressInfo): ValidateAddressResponse => {
    const errors = [];
    const { firstName, lastName, address1, zipCode, city } = data;

    if (firstName.length < 2) {
        errors.push('Your first name is too short. We require at least 2 characters.');
    }

    if (lastName.length < 2) {
        errors.push('Your last name is too short. We require at least 2 characters.');
    }

    if (!address1) {
        errors.push('Your address is empty.');
    }

    if (!zipCode) {
        errors.push('Your post code is empty.');
    }

    if (!city) {
        errors.push('Your city is empty.');
    }

    if (containsUnsupportedCharacters(firstName)) {
        errors.push('Your first name contains unsupported characters.');
    }

    if (containsUnsupportedCharacters(lastName)) {
        errors.push('Your last name contains unsupported characters.');
    }

    if (containsUnsupportedCharacters(address1)) {
        errors.push('Your address contains unsupported characters.');
    }

    if (containsUnsupportedCharacters(zipCode)) {
        errors.push('Your post code contains unsupported characters.');
    }

    if (containsUnsupportedCharacters(city)) {
        errors.push('Your city contains unsupported characters.');
    }

    return {
        isValid: errors.length === 0,
        errors,
    };
};

export default validateAddress;
